/*
  DATABASE ACTIONS
 */
export const REFRESH_DATABASE = 'REFRESH_DATABASE';
export const REFRESH_DATABASE_SUCCESS = 'REFRESH_DATABASE_SUCCESS';
export const REFRESH_DATABASE_FAILURE = 'REFRESH_DATABASE_FAILURE';
